/* eslint-disable import/prefer-default-export */
export const API = window.location.origin;
